import React from 'react';
import { Row } from 'antd';
import moment from 'moment';

const soonaMigrationUrl = new URL('https://support.soona.co/tren');

const PromoBanner = ({ extendedDeadline }) => {
  const today = moment();
  const extendedDeadlineTime = moment(extendedDeadline);

  const promoContent = () => {
    return `Trend is becoming soona. The last day to create new campaigns on Trend is 9/30/26. More info here.`;
  };

  const isBannerVisible = () => {
    return today <= extendedDeadlineTime;
  };

  if (!isBannerVisible()) return <></>;

  return (
    <Row className="promo-banner">
      <a href={soonaMigrationUrl} target="_blank" rel="noreferrer">
        {promoContent()}
      </a>
    </Row>
  );
};

export default PromoBanner;
